import { Trans, useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export type AccountLockedOutErrorProps = {
    minutesUntilUnlock?: number;
};

export const AccountLockedOutError = ({
    minutesUntilUnlock,
}: AccountLockedOutErrorProps) => {
    const { t } = useTranslation();

    return (
        <Alert data-testid="account-locked-out-error" severity="warning">
            {minutesUntilUnlock ? (
                <Trans
                    i18nKey={
                        minutesUntilUnlock === 1
                            ? 'formErrors.accountLockedOutError.withOneMinute'
                            : 'formErrors.accountLockedOutError.withMinutes'
                    }
                    values={{ minutes: minutesUntilUnlock }}
                    components={{
                        bold: <strong />,
                    }}
                />
            ) : (
                t('formErrors.accountLockedOutError.default')
            )}
        </Alert>
    );
};
